/* eslint-disable react-hooks/exhaustive-deps,no-nested-ternary,no-shadow,prefer-destructuring */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./RejectedTrafficDetailContainer.less";
import moment from "moment";
import { useParams } from "react-router";
import { Form } from "antd";
import { fetchRejectedTrafficDetail } from "../../store/slices/rejected-traffic";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import RejectedTrafficDetail from "../../components/RejectedTrafficDetail/RejectedTrafficDetail";
import { fetchTrafficStatus } from "../../store/slices/rtkDictionaries";

const RejectedTrafficDetailContainer = () => {
  const { rejectedTrafficsDetail, rejectedTrafficsDetailLoading } = useSelector(
    (state) => state.rejected
  );
  const dispatch = useDispatch();
  const { id } = useParams();
  const [form] = Form.useForm();
  const nowDate = moment();
  const pastDate = moment().subtract(30, "days");
  const dataDetails = JSON.parse(localStorage.getItem(id));

  const rejectedTrafficDetailSearchParams = {
    page: 0,
    size: 20,
    subscribers: !dataDetails?.role ? id : "",
    senderSubscribers: dataDetails?.role === "SENDER" ? dataDetails?.subscriber : "",
    recipientSubscribers: dataDetails?.role === "RECIPIENT" ? dataDetails?.subscriber : "",
    includeServiceUsageStatusIds: dataDetails ? dataDetails?.serviceUsageStatusId : "",
    includeDocumentIds: "",
    rangeDate: [
      dataDetails ? moment(dataDetails?.fromDate, "YYYY-MM-DDTHH:mm:ss.SSSZ") : pastDate,
      dataDetails ? moment(dataDetails?.toDate, "YYYY-MM-DDTHH:mm:ss.SSSZ") : nowDate,
    ],
  };

  const initialParamsState = {
    ...rejectedTrafficDetailSearchParams,
    fromDate: dataDetails
      ? toHttpFormatStartOfDay(
          moment(rejectedTrafficDetailSearchParams.rangeDate[0], "YYYY-MM-DDTHH:mm:ss.SSSZ")
        )
      : toHttpFormatStartOfDay(pastDate),
    toDate: dataDetails
      ? toHttpFormatEndOfDay(
          moment(rejectedTrafficDetailSearchParams.rangeDate[1], "YYYY-MM-DDTHH:mm:ss.SSSZ")
        )
      : toHttpFormatEndOfDay(nowDate),
    rangeDate: "",
  };

  const [rejectParams, setRejectParams] = useState(initialParamsState);

  useEffect(() => {
    dispatch(fetchTrafficStatus());
    dispatch(fetchRejectedTrafficDetail(rejectParams));
  }, []);

  const getValueRejectedTrafficDetailPagingAndFilters = (field) => rejectParams[field];

  const handlePageSize = (field, value) => {
    switch (field) {
      case "size":
        setRejectParams({ ...rejectParams, size: Number(value), page: 0 });
        dispatch(fetchRejectedTrafficDetail({ ...rejectParams, size: Number(value), page: 0 }));
        break;
      case "page":
        setRejectParams({ ...rejectParams, page: Number(value) - 1 });
        dispatch(fetchRejectedTrafficDetail({ ...rejectParams, page: Number(value) - 1 }));
        break;
      default:
        break;
    }
  };

  const handleSearchRejectsTraffic = (values) => {
    dispatch(fetchRejectedTrafficDetail(values));
    setRejectParams(values);
  };

  const resetSearchRejectsTraffic = () => {
    form.setFieldsValue(rejectedTrafficDetailSearchParams);
    setRejectParams(initialParamsState);
    dispatch(fetchRejectedTrafficDetail(initialParamsState));
  };

  return (
    <RejectedTrafficDetail
      dataDetails={dataDetails}
      rejectedTrafficsDetail={rejectedTrafficsDetail}
      rejectedTrafficsDetailLoading={rejectedTrafficsDetailLoading}
      getValueRejectedTrafficDetailPagingAndFilters={getValueRejectedTrafficDetailPagingAndFilters}
      handleSearchRejectsTraffic={handleSearchRejectsTraffic}
      resetSearchRejectsTraffic={resetSearchRejectsTraffic}
      handlePageSize={handlePageSize}
      form={form}
      rejectedTrafficDetailSearchParams={rejectedTrafficDetailSearchParams}
      rejectParams={rejectParams}
    />
  );
};

export default RejectedTrafficDetailContainer;
